module.exports = __webpack_public_path__ + "img/ergo-essential3.175ca44c.png";